import { getImagePath } from './productImageUtils';
import { getSessionStore } from '../../store/createStore';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

const getUplaodObject = (strType, index, type, fromWebstore) => {
    let supplierId = ''; 
    if(!fromWebstore){
        supplierId = getSessionStore().supplierId;
    }
    let url = fromWebstore ? '/marketplace/products/ajax/uploadProductImageForAdmin.service' : `/marketplace/products/ajax/uploadProductImageForB2B.service?supplierId=${supplierId}`;
    let data = {
        uploadSize: "10",
        ajaxUrl: location.protocol + "//" + location.host + url,
        fileType: "jpeg,jpg,png",
        fieldName: "uploadedImageFile",
        strType: strType,
        index: index,
        type: type
    }
    return data;
};

export const openGallery = ({ index, callback, fromWebstore}) => {
    if (window.jdInterface) {
        let data = getUplaodObject("changeImage", index, "GALLERY", fromWebstore);
        window.jdInterface.uploadImage(JSON.stringify(data));
        window.jdInterface.appImageSuccess = function (value) {
            callback(value);
        }
    }
};

export const onImageUploadFromAppSuccess = (res, props, productId, cb) => {
        if (res.data) {
            let _data = JSON.parse(res.data)[0];
            if (_data.status === "success"){
                let payload = {
                    imgURL: _data.imgURL,
                    actualPath: getImagePath(_data.imgURL),
                    imgIndex: +new Date() + productId + '0',
                    uploaded: true,
                    productId: productId,
                    noOfFilesToUpload: 1
                };
                props.updateProductImage({
                    imageUrl: payload,
                    editProductId: payload.productId,
                    imgIndex: payload.imgIndex,
                    noOfFilesToUpload: '1',
                    ignoreSave: false,
                    fromApp: true,
                    updateDefaultIndex: res.indexToReplace,
                    showToastMessage: res.showToastMessage ? props.showToastMessage : null
                });
                cb && cb();
                window.hideLoader && window.hideLoader(true);
          }
        } else {
            window.showLoader && window.showLoader();
        }
}

export function pageLoad(){
    const logjson = JSON.stringify({"pageload":"1"});
    if(window.JdLiteInterface && window.JdLiteInterface.verticalHandler){
        window.JdLiteInterface.verticalHandler(logjson);
    };
}

export function pageLoadForIos() {
    const logjson = JSON.stringify({ "pageload": "1" });
    if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
        window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
    }
}

export function callBackForApps(docId, appVersion, isJdSourceAndroid, isJdSourceIOS) {
    if (isJdSourceAndroid && parseInt(appVersion) >= 1288) {
        const logjson = JSON.stringify({"refresh":'1', "docid":docId});
        if (window.JdLiteInterface && window.JdLiteInterface?.myBusinessProfileScoreChanged) {
            window.JdLiteInterface?.myBusinessProfileScoreChanged(logjson);
        }
    } else if (isJdSourceIOS && parseFloat(appVersion) >= 15.2) {
        const logjson = JSON.stringify({"type":'myBusinessProfileScoreChanged', "refresh":'1', "docid":docId});
        if (window.webkit && window.webkit.messageHandlers['callbackHandler']) {
            window.webkit.messageHandlers.callbackHandler.postMessage(logjson);
        }        
    }
}

export const  withDCOnly=(WrappedComponent)=>{
    const DCOnly=(props)=>{
        const session = useSelector(state => state?.session)

        if(session?.viaOmni==true) return <></>
        return <WrappedComponent {...props} />
    }
    return DCOnly
}

export const DCOnlyComp =withDCOnly((props)=>{
    return props.children
})
